import React, {useEffect, useState} from "react";
import ApiRoute, {shopId} from "../../../helper/api";
import {toast} from "react-toastify";
import Layout from "../../../components/Layout";
import SearchBox from "../../../components/SearchBox";
import FilterBox from "../../../components/FilterBox";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faTrash, faArrowUp, faArrowDown} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../../components/Pagination";
import Modal from "../../../components/Utilities/Modal";
import Buttons from "react-multi-date-picker/components/button";
import AttributeSelect from "../../../components/Product/AttributeSelect";
import CategorySelect from "../../../components/Product/Category/CategorySelect";


function AttributesSorting() {

    const [openModal, setOpenModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [createMode, setCreateMode] = useState(false);
    const [orderedAttributes, setOrderedAttributes] = useState([])

    const [data,setData] = useState(null)
    

    const selectedItemStructure = {
        label: '',
        attributes: []
    }

    const [pageNumber, setPageNumber] = useState(1)
    const [paginationData, setPaginationData] = useState({})
    
    const [filterQuery, setFilterQuery] = useState({})

    const arraysEqual = (a = [], b = []) => {
        if (a === b) return true
        if (!Array.isArray(a) || !Array.isArray(b)) return false
        if (a.length !== b.length) return false
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false
        }
        return true
    }

    useEffect(() => {
        if (createMode){
            const fresh = { label: '', attributes: [] }
            setSelectedItem(fresh)
            setOrderedAttributes(fresh.attributes)
        }
    }, [createMode]);

    useEffect(() => {
        if (openModal && selectedItem){
            setOrderedAttributes(Array.isArray(selectedItem.attributes) ? selectedItem.attributes : [])
        }
    }, [openModal, selectedItem])

    //fetch data from server and update data /| based on updateData state
    useEffect(() => {
        (async () => {
            const  response  = await ApiRoute.product.attributes.sorting.index.fn({
                shop_id: shopId(),
                page : pageNumber
            }, filterQuery)

            if (response?.results) {
                setData(response.results.data || [])
                setPaginationData(response.results || {})
            } else {
                setData([])
                setPaginationData({})
            }
        })();
    }, [pageNumber, filterQuery]);

    

    async function getData(){
        const response = await ApiRoute.product.attributes.sorting.index.fn({
            shop_id: shopId(),
            page: pageNumber
        }, filterQuery)
        if (response?.results) {
            setData(response.results.data || [])
            setPaginationData(response.results || {})
        } else {
            setData([])
            setPaginationData({})
        }
    }

    async function handleCreate(){
        try {
            await ApiRoute.product.attributes.sorting.create.fn({ ...(selectedItem || {}), attributes: orderedAttributes })
            //toast.success("با موفقیت انجام شد")
        }catch (e) {
            toast.error(e)
        }

        await getData()
    }

    // removed updateData mechanism; fetching now depends on pageNumber and filterQuery

    async function handleUpdate() {
        try {
            await ApiRoute.product.attributes.sorting.update.fn(selectedItem._id, { ...(selectedItem || {}), attributes: orderedAttributes })
            //toast.success("با موفقیت انجام شد")
        }catch (e) {
            toast.error(e)
        }

        await getData()
    }

    const moveAttribute = (index, direction) => {
        setOrderedAttributes(prev => {
            const attrs = Array.isArray(prev) ? [...prev] : []
            const targetIndex = index + direction
            if (targetIndex < 0 || targetIndex >= attrs.length) { return prev }
            const temp = attrs[index]
            attrs[index] = attrs[targetIndex]
            attrs[targetIndex] = temp
            return attrs
        })
    }

    const removeAttribute = (index) => {
        setOrderedAttributes(prev => (Array.isArray(prev) ? prev.filter((_, i) => i !== index) : []))
    }

    async function handleDelete(item) {
        try {
            await ApiRoute.product.attributes.sorting.remove.fn(item._id)
            //toast.success("با موفقیت انجام شد")
        }catch (e) {
            toast.error(e)
        }

        await getData()
    }

    return (
        <Layout>
            <div>
                <div className="flex items-center justify-between mb-3">
                    <div className="page-title flex-auto ml-3 md:ml-0">
                        <span className="inline-block bg-white pl-3">مرتب سازی ویژگی</span>
                    </div>
                </div>

                <div className="grid md:flex justify-between items-center gap-3">
                    <div className="flex gap-3">
                        <SearchBox SetSearchQuery={ (v) => {
                            setFilterQuery({ title: v.term })
                        } }/>
                    </div>
                    <button className="btn-blue text-center hidden md:block" onClick={ e => {
                        setCreateMode(true)
                        setOpenModal(true)
                    } }>افزودن</button>
                </div>
                <FilterBox/>

                {data && <div className="main-content p-3 mt-3">

                    <div className="grid grid-cols-11 text-sm border-b border-b-gray-7 py-3">
                        <div className="col-span-3 text-center">عنوان</div>
                    </div>
                    {data.map((item, id) =>
                        <div key={id}>
                            <div
                                className="grid grid-cols-11 text-xs items-center rounded box-tr-style py-1.5 my-2">
                                <div className="col-span-3 text-center">{item.title}</div>
                                <div className="col-span-3 text-left pl-4">
                                    <button className="mx-1" title="ویرایش"
                                            onClick={() => {
                                                setCreateMode(false)
                                                setOpenModal(true)
                                                setSelectedItem(item)
                                            }}>
                                        <FontAwesomeIcon
                                            className="bg-blue-2 text-white p-1 w-4 h-4 rounded" icon={faEdit}/>
                                    </button>
                                    <button className="mx-2" onClick={ async () => await handleDelete(item) } title="حذف" ><FontAwesomeIcon
                                        className="bg-red-1 text-white p-1 w-4 h-4 rounded" icon={faTrash}/></button>
                                </div>
                            </div>
                        </div>
                    )}

                    {paginationData && typeof paginationData.total !== 'undefined' && (
                        <Pagination SetPageNumber={setPageNumber} Data={paginationData}/>
                    )}


                </div>}



            </div>


            <Modal isOpen={openModal}>

                <div className="flex justify-between mx-auto mb-5">
                    <h4 className="text-[#000]">
                        {createMode ? 'افزودن مرتب سازی' : 'ویرایش مرتب سازی'}
                    </h4>
                    <Buttons onClick={ (e) => {setOpenModal(false); setSelectedItem(selectedItemStructure)} } className="btn-gray py-1.5">بستن</Buttons>
                </div>

                <div className={`p-3`}>
                    <div
                        className="grid grid-cols-1 lg:grid-cols-1 text-[14px] gap-5 td items-end">
                        <label className="">
                            <span className="text-right">عنوان</span>
                            <input
                                onChange={ (e) => {
                                    const val = e.target.value
                                    setSelectedItem(prev => ({ ...(prev || {}), title: val }))
                                } }
                                className="!mr-0 mt-2 rounded p-1 border-gray-3 shadow-sm border w-full" type="text" defaultValue={selectedItem?.title}/>
                        </label>

                        <div className="">
                            <label className="pb-2">دسته ها</label>
                            <CategorySelect assignItem={ async (s) => {
                                if (!selectedItem){return}
                                const slugs = (s || []).map(c => c.slug || c.name)
                                setSelectedItem(prev => {
                                    const prevSlugs = prev?.slugs || []
                                    if (arraysEqual(prevSlugs, slugs)) return prev
                                    return ({ ...(prev || {}), slugs })
                                })
                            } } defaultValue={selectedItem?.slugs}/>
                        </div>

                        <div className="">
                            <label className="pb-2">ویژگی ها</label>
                            <AttributeSelect assignItem={ async (s) => {
                                if (!selectedItem){return}
                                const arr = (s || []).map(a => a.name)
                                setSelectedItem(prev => {
                                    const prevAttrs = prev?.attributes || []
                                    if (arraysEqual(prevAttrs, arr)) return prev
                                    return ({ ...(prev || {}), attributes: arr })
                                })
                                setOrderedAttributes(prev => (arraysEqual(prev, arr) ? prev : arr))
                            } } defaultValue={selectedItem?.attributes}/>

                            {orderedAttributes?.length > 0 && (
                                <div className="mt-3 border border-gray-3 rounded">
                                    <div className="p-2 text-xs text-gray-600">ترتیب ویژگی های انتخاب شده</div>
                                    <div className="divide-y divide-gray-2">
                                        {orderedAttributes.map((attr, index) => (
                                            <div key={`${attr}-${index}`} className="flex items-center justify-between p-2 text-sm">
                                                <div className="truncate mr-2">{attr}</div>
                                                <div className="flex items-center gap-2">
                                                    <button type="button" className="mx-1" title="بالا"
                                                            onClick={() => moveAttribute(index, -1)}>
                                                        <FontAwesomeIcon className="bg-gray-5 text-white p-1 w-4 h-4 rounded" icon={faArrowUp}/>
                                                    </button>
                                                    <button type="button" className="mx-1" title="پایین"
                                                            onClick={() => moveAttribute(index, 1)}>
                                                        <FontAwesomeIcon className="bg-gray-5 text-white p-1 w-4 h-4 rounded" icon={faArrowDown}/>
                                                    </button>
                                                    <button type="button" className="mx-1" title="حذف"
                                                            onClick={() => removeAttribute(index)}>
                                                        <FontAwesomeIcon className="bg-red-1 text-white p-1 w-4 h-4 rounded" icon={faTrash}/>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>

                <div className="flex justify-between mx-auto mt-5">
                    <Buttons onClick={ async () => {
                        if (createMode){ await handleCreate()}else{ await handleUpdate()}
                    } } className="btn-purple w-36 py-1.5">ذخیره</Buttons>
                </div>
            </Modal>

            
        </Layout>
    )
}

export default AttributesSorting